import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon, Button, ModalWrapper, ModalCloseButton } from '../common';

/**
 * Figma: 프라이빗 이동, 프라이빗 투어>로그인 유도 모달
 * Desktop: 500x368, Mobile: 380x368
 * Shows when non-member clicks search
 */
export default function LoginPromptModal({ onClose, onGuestBooking, onBeforeLogin }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogin = () => {
    if (onBeforeLogin) onBeforeLogin();
    onClose();
    navigate('/login');
  };

  const handleSignup = () => {
    if (onBeforeLogin) onBeforeLogin();
    onClose();
    navigate('/signup');
  };

  return (
    <ModalWrapper padding="px-5 pt-5 pb-8" gap="gap-2.5">
      {/* Close Button */}
      <div className="flex justify-end">
        <ModalCloseButton onClick={onClose} />
      </div>

      {/* Icon Circle */}
      <div className="flex justify-center">
        <div className="w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center">
          <Icon name="notification" size={52} className="text-orange-500" />
        </div>
      </div>

      {/* Title */}
      <h2 className="text-xl font-bold text-mono-900 text-center mt-2">
        {t('common.wait_title')}
      </h2>

      {/* Description */}
      <p className="text-sm font-medium text-mono-900 text-center leading-[22.4px] break-keep">
        {t('common.guest_booking_prompt')}
      </p>

      {/* Buttons */}
      <div className="flex flex-col gap-2.5 mt-4">
        <div className="flex gap-2.5">
          <Button
            level="level3"
            fullWidth
            onClick={handleSignup}
          >
            {t('common.signup')}
          </Button>
          <Button
            level="level1"
            fullWidth
            onClick={handleLogin}
          >
            {t('common.login')}
          </Button>
        </div>
        <Button level="level5" fullWidth onClick={onGuestBooking}>
          {t('common.guest_booking')}
        </Button>
      </div>
    </ModalWrapper>
  );
}
